import { Avatar } from '@lmc/ui-kit'
import { getJSON } from 'common/services/api'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

export const ELIGIBLE_SECOND_SIGNERS_QUERY_KEY = [
  'second-signature-codes',
  'eligible-signers'
]

type EligibleSigner = {
  id: string
  name: string
  picture?: string
}

export type SecondSignerOption = {
  label: string
  value: string
  image: JSX.Element
}

const useEligibleSecondSigners = ({
  enabled = true
}: {
  enabled?: boolean
} = {}) => {
  const { data, isLoading, isError, refetch } = useQuery<EligibleSigner[]>(
    ELIGIBLE_SECOND_SIGNERS_QUERY_KEY,
    () => getJSON({ url: '/emar/second-signature-codes/eligible-signers' }),
    { enabled }
  )

  const options = useMemo<SecondSignerOption[]>(
    () =>
      (data ?? [])
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((signer) => ({
          label: signer.name,
          value: signer.id,
          image: <Avatar url={signer.picture} size={20} />
        })),
    [data]
  )

  return { options, isLoading, isError, refetch }
}

export default useEligibleSecondSigners
